/** biome-ignore-all lint/a11y/noLabelWithoutControl: <explanation> */
/** biome-ignore-all lint/a11y/noStaticElementInteractions: <explanation> */
import { type ReactNode, useState } from 'react'
import { cn } from '@/lib/utils'
import type { InputProps } from '../ui/input'

interface FloatLabelProps extends InputProps {
  label?: string
  hasValue?: boolean
  children: ReactNode
  className?: string
  classNameLabel?: string
  open?: boolean
}

export const FloatLabel = ({
  label,
  variant = 'default',
  hasValue = false,
  children,
  className,
  classNameLabel,
  open
}: FloatLabelProps) => {
  const [focus, setFocus] = useState(false)

  const isFloating = variant === 'floating' && !open
  const labelUp = variant === 'labelUp' || open
  const shouldFloat = focus || hasValue

  return (
    <div
      className={cn('relative w-full', className)}
      onFocus={() => setFocus(true)}
      onBlur={() => setFocus(false)}
    >
      {isFloating && label && (
        <label
          className={cn(
            'absolute left-3 top-2.5 text-muted-foreground text-sm transition-all pointer-events-none',
            shouldFloat && 'top-[-0.5rem] text-xs px-2 bg-white p-0 ml-2',
            classNameLabel
          )}
        >
          {label}
        </label>
      )}
      {labelUp && label && (
        <label
          className={cn(
            'absolute left-3 top-2 text-muted-foreground text-sm transition-all pointer-events-none',
            'top-[-0.5rem] text-xs px-2 bg-white p-0 ml-2'
          )}
        >
          {label}
        </label>
      )}
      {children}
    </div>
  )
}
